import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-100 h-screen w-full relative overflow-hidden flex flex-col" }
const _hoisted_2 = { class: "bg-blue-500 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10 text-2xl shrink-0" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  id: "table-title",
  class: "text-xl font-semibold text-2xl"
}
const _hoisted_5 = { class: "bg-white p-4 mb-2 flex justify-between items-center shrink-0" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex border rounded overflow-hidden" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  id: "people-count",
  class: "px-3 py-1 border-l border-r flex items-center justify-center min-w-[40px] text-2xl"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "flex items-center text-2xl" }
const _hoisted_12 = { id: "current-time" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "text-gray-500 mr-2" }
const _hoisted_15 = { class: "flex flex-row flex-1 min-h-0 overflow-hidden" }
const _hoisted_16 = { class: "w-1/4 bg-white overflow-y-auto border-r text-2xl min-h-0" }
const _hoisted_17 = { class: "sticky top-0 bg-gray-200 p-3" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = { class: "p-5" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "w-2/4 bg-white overflow-y-auto border-r text-2xl min-h-0" }
const _hoisted_22 = { class: "p-3 bg-gray-100 sticky top-0 z-10" }
const _hoisted_23 = { class: "font-bold" }
const _hoisted_24 = { class: "menu-items" }
const _hoisted_25 = ["aria-disabled", "onClick"]
const _hoisted_26 = { class: "menu-item-image" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "menu-item-content" }
const _hoisted_29 = { class: "menu-item-title" }
const _hoisted_30 = { class: "menu-item-desc" }
const _hoisted_31 = { class: "flex justify-between items-center" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "menu-item-price" }
const _hoisted_34 = { class: "flex items-center hidden" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "menu-item-count"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "px-3 py-2 bg-gray-100 sticky top-0 z-10 flex justify-between items-center text-xl shrink-0" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "flex-1 min-h-0 overflow-y-auto px-3 py-1" }
const _hoisted_41 = {
  key: 0,
  class: "text-center text-gray-500 py-10"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "order-item-info" }
const _hoisted_44 = { class: "order-item-name" }
const _hoisted_45 = {
  key: 0,
  class: "order-item-spec text-gray-500"
}
const _hoisted_46 = { class: "order-item-price" }
const _hoisted_47 = { class: "order-item-controls" }
const _hoisted_48 = ["disabled", "onClick"]
const _hoisted_49 = { class: "menu-item-count mr-2" }
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = { class: "px-3 py-2 border-t text-xl shrink-0 bg-white" }
const _hoisted_52 = { class: "mb-2 flex items-center" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "flex justify-between mb-2" }
const _hoisted_55 = { class: "text-base text-lg text-gray-500" }
const _hoisted_56 = { class: "flex justify-between items-center mb-2" }
const _hoisted_57 = { class: "flex items-center" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "text-red-500" }
const _hoisted_60 = { class: "flex justify-between font-bold" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_63 = { class: "bg-white rounded-xl p-6 w-80" }
const _hoisted_64 = { class: "mb-4" }
const _hoisted_65 = { class: "grid grid-cols-2 gap-2 mb-4" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "text-sm text-gray-500 mt-3" }
const _hoisted_69 = {
  key: 1,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_70 = {
  key: 2,
  class: "payment-modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_71 = { class: "payment-modal-card bg-white rounded-xl" }
const _hoisted_72 = { class: "payment-modal-body" }
const _hoisted_73 = { class: "payment-order-summary p-3 bg-gray-50 rounded-lg" }
const _hoisted_74 = { class: "flex justify-between items-center mb-2" }
const _hoisted_75 = { class: "font-medium" }
const _hoisted_76 = { class: "flex justify-between items-center mb-2" }
const _hoisted_77 = { class: "font-medium" }
const _hoisted_78 = { class: "flex justify-between items-center" }
const _hoisted_79 = { class: "text-xl font-bold text-red-500" }
const _hoisted_80 = { class: "payment-form space-y-4" }
const _hoisted_81 = ["value"]
const _hoisted_82 = {
  key: 0,
  class: "p-3 bg-yellow-50 rounded-lg"
}
const _hoisted_83 = {
  key: 0,
  class: "mb-3 text-sm text-red-500"
}
const _hoisted_84 = { class: "employee-validation-row" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = {
  key: 1,
  class: "mt-3 text-sm text-gray-700 space-y-1"
}
const _hoisted_88 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_89 = {
  key: 2,
  class: "mt-2 text-sm text-red-500"
}
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "payment-modal-footer flex space-x-3 border-t" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = {
  key: 3,
  class: "fixed inset-0 bg-black z-50 flex flex-col"
}
const _hoisted_94 = { class: "flex-1 relative overflow-hidden w-full h-full" }
const _hoisted_95 = {
  key: 0,
  class: "absolute inset-0 pointer-events-none z-20"
}
const _hoisted_96 = {
  key: 0,
  class: "bg-black bg-opacity-80 px-4 py-3"
}
const _hoisted_97 = { class: "text-sm font-medium" }
const _hoisted_98 = {
  key: 4,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_99 = { class: "bg-white rounded-xl p-6 w-96 max-w-md" }
const _hoisted_100 = { class: "mb-6" }
const _hoisted_101 = {
  key: 0,
  class: "text-red-500 text-sm mt-2"
}
const _hoisted_102 = { class: "flex flex-col space-y-3" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = ["disabled"]
const _hoisted_108 = {
  key: 5,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
  "data-modal": "spec-modal"
}
const _hoisted_109 = { class: "bg-white rounded-xl p-6 w-80 max-w-md" }
const _hoisted_110 = { class: "mb-4 p-3 bg-gray-50 rounded-lg" }
const _hoisted_111 = { class: "flex items-center" }
const _hoisted_112 = ["src", "alt"]
const _hoisted_113 = { class: "font-medium" }
const _hoisted_114 = { class: "text-gray-600 text-sm" }
const _hoisted_115 = { class: "mb-4" }
const _hoisted_116 = { class: "space-y-2" }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { class: "font-medium" }
const _hoisted_119 = {
  key: 0,
  class: "fas fa-check text-blue-500"
}
const _hoisted_120 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_121 = { class: "text-lg font-medium mb-3" }
const _hoisted_122 = { class: "flex flex-wrap gap-2" }
const _hoisted_123 = ["onClick"]

import { CategoryModel, CategoryItemModel } from '@/model/food';
  import { fetchCategoryItemList, foodUp, fetchCategoryTagList } from '@/service/food';
  import { fetchAddOrder, insertOrderPayment, completeOrder } from '@/service/order';
  import {
    fetchShopDetail,
    getBookTimeList,
    getDeliveryTimeList,
    getSelfPickTimeList,
    getShopConfigList,
  } from '@/service/base';
  import { getCustomerList } from '@/service/customer';
  import { showDialog, showToast } from 'vant';
  import type { PickerChangeEventParams, PickerConfirmEventParams, PickerOption } from 'vant';
  import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import ConfirmDialog from '@/components/ConfirmDialog.vue';
  import { OrderPaymentModel } from '@/model/orderPayment';
  import dayjs from 'dayjs';
  import { dateTimeFormat } from '@/utils/utils';
  import { scanPayment, refreshScanPayment } from '@/service/payment';
  import { Html5Qrcode } from 'html5-qrcode';
  import { useCurrentEmployee } from '@/composables/useCurrentEmployee';
  import { CustomerModel } from '@/model/customer';

  type DiscountMode = 'amount' | 'rate';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'OrderNewView',
  setup(__props) {

  const router = useRouter();
  const route = useRoute();
  const { employeeId, employeeName } = useCurrentEmployee();

  const tableNumber = ref(0);
  const tableName = ref('');
  const tableTag = ref('');
  const shopId = ref(0);
  const shopName = ref('');
  const cartType = ref(1); // 新增：1-正常点餐，2-直接支付
  const peopleCount = ref(1);
  const orderDescription = ref('');
  const currentTime = ref('');
  const searchKeyword = ref('');
  const qrModalVisible = ref(false);
  const timePickerVisible = ref(false);
  const selfPickDate = ref('');
  const selfPickTime = ref('');
  const selfPickDateTime = computed(() =>
    selfPickDate.value && selfPickTime.value ? `${selfPickDate.value} ${selfPickTime.value}` : '',
  );
  const availableDates = ref<string[]>([]);
  const availableTimeMap = ref<Record<string, string[]>>({});
  const selectedPickerDate = ref('');
  const timePickerValues = ref<Array<string | number>>([]);

  const getMenuTag = (tag: string, name: string): string => {
    const normalizedTag = tag.trim();
    if (normalizedTag) return normalizedTag;

    // 特殊桌可能只通过桌名区分；普通桌的空标签仍按堂食处理。
    if (name === '自提' || name === 'Pickup') return '自提';
    if (name === '外卖' || name === 'Delivery') return '外卖';
    if (name === '预定' || name === 'Reservation') return '预定';
    return '堂食';
  };

  const menuTag = computed(() => getMenuTag(tableTag.value, tableName.value));

  const getDineTypeByMenuTag = (tag: string): number => {
    if (tag === '自提') return 2;
    if (tag === '外卖') return 3;
    if (tag === '预定') return 5;
    return 1;
  };

  const dineType = computed(() => getDineTypeByMenuTag(menuTag.value));
  const isSpecialOrder = computed(() => [2, 3, 5].includes(dineType.value));
  const timeLabel = computed(() => {
    if (dineType.value === 2) return '自提时间';
    if (dineType.value === 3) return '外卖时间';
    if (dineType.value === 5) return '预定时间';
    return '就餐时间';
  });
  const timePickerColumns = computed<PickerOption[][]>(() => [
    availableDates.value.map((date) => ({ text: date, value: date })),
    (availableTimeMap.value[selectedPickerDate.value] || []).map((time) => ({
      text: time,
      value: time,
    })),
  ]);

  // 确认对话框相关
  const confirmDialog = ref<InstanceType<typeof ConfirmDialog>>();
  const confirmMessage = ref('');
  const confirmTitle = ref('');

  // 支付相关状态
  const paymentConfirmModalVisible = ref(false);
  const selectedPaymentMethod = ref(4); // 默认选择POS支付，如果有B扫C收款会自动更新
  const paymentRemark = ref('');
  const currentOrderId = ref(0);
  const currentOrderNo = ref('');
  const tableOrderCompleteType = ref<number | null>(null); // 保存订单返回的tableOrderCompleteType
  const isSubmittingOrder = ref(false);
  const hasPendingPayment = computed(() => cartType.value === 2 && currentOrderId.value > 0);
  const foodTicketEnabled = ref(false);
  const foodTicketEmployeeNo = ref('');
  const foodTicketCustomer = ref<CustomerModel | null>(null);
  const isValidatingEmployee = ref(false);
  const hasEnoughFoodTicketBalance = computed(
    () =>
      Boolean(foodTicketCustomer.value) &&
      Number(foodTicketCustomer.value?.foodTicketAccount || 0) >= total.value,
  );

  // 扫码支付相关状态
  const scanPaymentModalVisible = ref(false);
  const isScanning = ref(false);
  const scanPaymentRemark = ref('');
  const scanStatus = ref('');
  const scanStatusClass = ref('');
  const scanPaymentFailModalVisible = ref(false); // 扫码支付失败确认模态框
  const scanPaymentFailErrorMsg = ref(''); // 扫码支付失败错误信息
  const isRefreshingPayment = ref(false); // 是否正在刷新支付状态
  let html5QrCode: Html5Qrcode | null = null;

  // 店铺详情和营业时间相关状态
  const shopDetail = ref<any>(null);
  const isOnlinePayment = ref(false); // 是否为线上支付
  const businessTimeList = ref<Array<{ beginTime: string; endTime: string }>>([]);

  const discountMode = ref<DiscountMode>('rate');
  const manualDiscountAmount = ref(0);
  const discountRate = ref(1);
  const discountModalVisible = ref(false);
  const tempDiscountMode = ref<DiscountMode>('rate');
  const tempManualDiscountAmount = ref(0);
  const tempDiscountRate = ref(1);

  // 规格选择相关状态
  const showSpecModalVisible = ref(false);
  const currentFood = ref<any>({});
  const selectedSpec = ref<any>({});
  const selectedMethod = ref(0);
  const selectedMethods = ref<{ [key: string]: number | number[] }>({}); // 支持多个属性选择
  const currentEvent = ref<Event | undefined>(undefined); // 保存原始点击事件
  const methods = ref<
    Array<{
      id: number;
      name: string;
      cookId?: number;
      cookName?: string;
      cookType?: number;
      attributeName?: string; // 新增属性名称字段
    }>
  >([]);

  const categories = ref<CategoryModel[]>([]);

  const selectedCategory = ref('');

  const orderItems = ref<
    {
      id: number;
      name: string;
      price: number;
      quantity: number;
      shopFoodSpecId: number;
      isFoodTicket?: 0 | 1;
      specName?: string;
      methodName?: string;
    }[]
  >([]);

  const unsupportedFoodTicketNames = computed(() => [
    ...new Set(orderItems.value.filter((item) => item.isFoodTicket !== 1).map((item) => item.name)),
  ]);

  const orderPanel = ref<HTMLElement | null>(null);

  // 支付方式列表
  const paymentMethods = computed(() => {
    const methods = [
      { value: 4, name: 'POS支付' },
      { value: 5, name: '公司挂账' },
      { value: 7, name: '现金支付' },
    ];
    // 如果支持在线支付，添加B扫C收款选项
    if (isOnlinePayment.value) {
      methods.unshift({ value: 3, name: 'B扫C收款' });
    }
    if (foodTicketEnabled.value && (!hasPendingPayment.value || foodTicketCustomer.value)) {
      methods.push({ value: 100, name: '餐券支付' });
    }
    return methods;
  });

  // 从登录态获取工号
  const getEmployeeId = () => {
    return employeeId.value;
  };

  // 从登录态获取员工姓名
  const getEmployeeName = () => {
    return employeeName.value;
  };

  // 按属性名称分组的计算属性
  const groupedMethods = computed(() => {
    const groups: { [key: string]: any[] } = {};
    methods.value.forEach((method) => {
      const attributeName = method.attributeName || method.cookName || '做法';
      if (!groups[attributeName]) {
        groups[attributeName] = [];
      }
      groups[attributeName].push(method);
    });
    return groups;
  });

  // 所有菜品的完整列表，用于左侧选择“全部”时展示
  const allMenuItems = ref<CategoryItemModel[]>([]);

  const filteredMenuItems = computed<CategoryItemModel[]>(() => {
    let items: CategoryItemModel[] = [];

    if (selectedCategory.value === '全部') {
      // 如果是"全部"分类，直接展示所有菜品（不再通过标签/分类拼接）
      items = allMenuItems.value;
    } else {
      // 否则只显示选中分类的菜品
      const selectedCat = categories.value.find((cat) => cat.name === selectedCategory.value);
      items = selectedCat?.items || [];
    }

    const filteredItems = searchKeyword.value
      ? items.filter(
          (item) =>
            item.name?.includes(searchKeyword.value) ||
            item.description?.includes(searchKeyword.value),
        )
      : items;

    return [...filteredItems].sort((firstItem, secondItem) => {
      const firstOutOfStock = (firstItem.stockQuantity ?? 0) <= 0;
      const secondOutOfStock = (secondItem.stockQuantity ?? 0) <= 0;
      return Number(firstOutOfStock) - Number(secondOutOfStock);
    });
  });

  const getOrderItemCount = (name: string) => {
    const found = orderItems.value.find((item) => item.name === name);
    return found ? found.quantity : 0;
  };

  const addToOrder = (item: any, event: any) => {
    if (hasPendingPayment.value) return;
    if ((item.stockQuantity ?? 0) <= 0) {
      showToast('该菜品库存不足，暂时无法添加');
      return;
    }
    if (!item.specs || item.specs.length === 0) {
      showToast('该菜品未配置规格，暂时无法添加');
      return;
    }
    // 1. 订单逻辑
    const found = orderItems.value.find((o) => o.id === item.id);
    if (found) {
      found.quantity += 1;
    } else {
      orderItems.value.push({ ...item, quantity: 1 });
    }
    // 2. 动画 - 等待DOM更新后执行
    nextTick(() => {
      flyToOrder(event);
    });
  };

  const flyToOrder = (event: any) => {
    console.log('开始飞入动画', event);

    const menuItem = event.target.closest('.menu-item');
    if (!menuItem) {
      console.log('未找到menu-item元素');
      return;
    }

    const img = menuItem.querySelector('img');
    if (!img) {
      console.log('未找到图片元素');
      return;
    }

    if (!orderPanel.value) {
      console.log('未找到订单面板元素');
      return;
    }

    const imgRect = img.getBoundingClientRect();
    const orderRect = orderPanel.value.getBoundingClientRect();

    console.log('图片位置:', imgRect);
    console.log('订单面板位置:', orderRect);

    const clone = img.cloneNode(true) as HTMLImageElement;
    clone.style.position = 'fixed';
    clone.style.left = imgRect.left + 'px';
    clone.style.top = imgRect.top + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    clone.style.zIndex = '9999';
    clone.style.borderRadius = '8px';
    clone.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
    clone.style.transition = 'all 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    clone.style.pointerEvents = 'none';
    clone.style.opacity = '1';
    document.body.appendChild(clone);

    // 查找订单区中该商品的元素
    let orderTarget = null;
    const orderItemsElements = orderPanel.value.querySelectorAll('.order-item');
    orderItemsElements.forEach((orderItem: any) => {
      const orderName = orderItem.querySelector('.order-item-name');
      if (
        orderName &&
        orderName.textContent ===
          (event.target.closest('.menu-item')?.querySelector('.menu-item-title')?.textContent || '')
      ) {
        orderTarget = orderItem;
      }
    });

    let targetX, targetY;
    if (orderTarget) {
      // 已有该商品，飞向该商品
      const orderItemRect = (orderTarget as HTMLElement).getBoundingClientRect();
      targetX = orderItemRect.left + orderItemRect.width / 2 - imgRect.width / 2;
      targetY = orderItemRect.top + orderItemRect.height / 2 - imgRect.height / 2;
    } else {
      // 没有该商品，飞向订单区顶部
      targetX = orderRect.left + orderRect.width / 2 - imgRect.width / 2;
      targetY = orderRect.top + 30;
    }

    nextTick(() => {
      console.log('目标位置:', { targetX, targetY });

      clone.style.transform = `translate(${targetX - imgRect.left}px, ${
        targetY - imgRect.top
      }px) scale(0.3)`;
      clone.style.opacity = '0.5';
    });

    setTimeout(() => {
      if (clone.parentNode) {
        clone.parentNode.removeChild(clone);
      }
      console.log('动画完成，移除克隆元素');
    }, 1200);
  };

  const decreaseItem = (name: string) => {
    if (hasPendingPayment.value) return;
    const idx = orderItems.value.findIndex((item) => item.name === name);
    if (idx !== -1) {
      if (orderItems.value[idx].quantity > 1) {
        orderItems.value[idx].quantity -= 1;
      } else {
        orderItems.value.splice(idx, 1);
      }
    }
  };

  const clearOrder = async () => {
    if (hasPendingPayment.value) return;
    if (orderItems.value.length === 0) return;
    confirmMessage.value = '确定要清空所有已点菜品吗？';
    confirmTitle.value = '清空确认';
    if (await confirmDialog.value?.show()) {
      orderItems.value = [];
    }
  };

  const subtotal = computed(() =>
    orderItems.value.reduce((sum, item) => sum + item.price * item.quantity, 0),
  );
  const discountAmount = computed(() => {
    const amount =
      discountMode.value === 'amount'
        ? manualDiscountAmount.value
        : subtotal.value * (1 - discountRate.value);
    return Math.min(subtotal.value, Math.max(0, Math.round(amount * 100) / 100));
  });
  const total = computed(() => Math.max(0, subtotal.value - discountAmount.value));
  const totalCount = computed(() => orderItems.value.reduce((sum, item) => sum + item.quantity, 0));

  const selectCategory = (name: string) => {
    selectedCategory.value = name;
  };

  const increasePeople = () => {
    if (hasPendingPayment.value) return;
    peopleCount.value += 1;
  };
  const decreasePeople = () => {
    if (hasPendingPayment.value) return;
    if (peopleCount.value > 1) peopleCount.value -= 1;
  };

  const showQRCode = () => {
    qrModalVisible.value = true;
  };
  const hideQRCode = () => {
    qrModalVisible.value = false;
  };

  const submitOrder = async () => {
    // 订单一旦创建成功，提交入口只负责继续支付，不能再次创建订单。
    if (hasPendingPayment.value) {
      showPaymentConfirmModal();
      return;
    }

    if (isSubmittingOrder.value) return;
    if (orderItems.value.length === 0) return;

    if (orderItems.value.some((item) => !item.shopFoodSpecId || item.shopFoodSpecId <= 0)) {
      showToast('订单中存在未配置规格的菜品，请移除后重试');
      return;
    }

    if (isSpecialOrder.value && !selfPickDateTime.value) {
      showToast(`请选择${timeLabel.value}`);
      return;
    }

    // 检查营业时间
    const canProceed = await checkBusinessTime();
    if (!canProceed) {
      return;
    }

    if (cartType.value === 2) {
      showPaymentConfirmModal();
      return;
    }

    await createOrder();
  };

  const createOrder = async (): Promise<boolean> => {
    if (isSubmittingOrder.value || currentOrderId.value) return Boolean(currentOrderId.value);

    // 添加详细的调试信息
    console.log('=== 提交订单调试信息 ===');
    console.log('orderItems:', orderItems.value);
    console.log('subtotal:', subtotal.value);
    console.log('discountAmount:', discountAmount.value);
    console.log('total:', total.value);
    console.log('totalCount:', totalCount.value);
    console.log('peopleCount:', peopleCount.value);
    console.log('tableName:', tableName.value);
    console.log('shopId:', shopId.value);
    console.log('========================');

    // 构建符合接口要求的订单数据
    const orderData = {
      shopId: shopId.value,
      tableId: tableNumber.value, // 假设tableId就是tableNumber
      tableUniqueCode: `TABLE_${tableNumber.value}`, // 生成餐桌唯一标识
      customerId:
        selectedPaymentMethod.value === 100 ? foodTicketCustomer.value?.customerId : undefined,
      customerName:
        selectedPaymentMethod.value === 100 ? foodTicketCustomer.value?.customerName : undefined,
      userId: getEmployeeId(), // 使用保存的工号
      userName: getEmployeeName(), // 使用保存的工号，如果没有则使用默认值
      orderStatus: 1, // 订单状态：1-待确认
      orderNo: generateOrderNo(), // 生成订单编号
      orderType: 1, // 订单类型：1-堂食
      orderChannel: '服务员点餐', // 下单渠道
      dineType: dineType.value, // 就餐类型：1-堂食，2-自提，3-外卖，5-预定
      personCount: peopleCount.value, // 用餐人数
      totalAmount: total.value, // 总金额
      discountAmount: discountAmount.value, // 折扣金额
      foodAmount: subtotal.value, // 菜品金额
      serviceAmount: 0, // 服务费
      packageAmount: 0, // 包装费
      description: orderDescription.value.trim(),
      selfPickDate: isSpecialOrder.value ? selfPickDate.value : '',
      selfPickTime: isSpecialOrder.value ? selfPickTime.value : '',
      // description: `桌号：${tableName.value}，用餐人数：${peopleCount.value}人`,
      foodList: orderItems.value.map((item) => ({
        shopFoodId: item.id, // 使用菜品ID
        shopFoodSpecId: item.shopFoodSpecId, // 规格ID，默认1
        foodCookDesc: item.methodName || '', // 使用组合的methodName作为foodCookDesc
        quantity: item.quantity,
        price: item.price,
        amount: item.price * item.quantity,
        sourcePrice: item.price,
        sourceAmount: item.price * item.quantity,
        priority: 1, // 优先级
        addType: 1, // 添加类型：1-正常添加
        addPerson: getEmployeeName(), // 使用保存的工号
      })),
      paymentList: [], // 支付列表，提交订单时为空
    };

    console.log('完整订单数据:', orderData);

    isSubmittingOrder.value = true;
    try {
      // 调用提交订单接口
      const response = await fetchAddOrder(orderData);
      if (response.code === 200) {
        console.log('订单提交成功，订单ID:', response.result.orderId);

        // 保存订单信息；后续所有重试均复用此订单ID。
        currentOrderId.value = response.result.orderId;
        currentOrderNo.value = orderData.orderNo;
        tableOrderCompleteType.value = response.result.tableOrderCompleteType;
        if (cartType.value === 2) {
          return true;
        } else {
          alert(
            `${tableName.value}订单已提交成功！\n总金额：¥${total.value}\n共${totalCount.value}份菜品\n\n正在返回桌位管理页面...`,
          );
          router.push('/tableManage');
          return true;
        }
      } else {
        alert(response.msg || '订单提交失败，请稍后重试');
        return false;
      }
    } catch (error) {
      console.error('提交订单失败:', error);
      showToast('订单提交失败，请稍后重试');
      return false;
    } finally {
      isSubmittingOrder.value = false;
    }
  };

  // 生成订单编号
  const generateOrderNo = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const second = String(now.getSeconds()).padStart(2, '0');
    const random = Math.floor(Math.random() * 1000)
      .toString()
      .padStart(3, '0');

    return `ORDER${year}${month}${day}${hour}${minute}${second}${random}`;
  };

  const goToHistory = () => {
    router.push('/orderHistory');
  };
  const showMenu = () => {
    // 可扩展：显示更多菜单
  };

  const adjustDiscount = () => {
    if (hasPendingPayment.value) {
      showToast('订单已创建，支付完成前不能修改订单');
      return;
    }
    tempDiscountMode.value = discountMode.value;
    tempManualDiscountAmount.value = manualDiscountAmount.value;
    tempDiscountRate.value = discountRate.value;
    discountModalVisible.value = true;
  };

  const hideDiscountModal = () => {
    discountModalVisible.value = false;
  };

  // 支付相关方法
  const showPaymentConfirmModal = () => {
    // 如果有B扫C收款选项，默认选择B扫C收款，否则选择POS支付
    selectedPaymentMethod.value = isOnlinePayment.value ? 3 : 4;
    paymentRemark.value = '';
    paymentConfirmModalVisible.value = true;
  };

  const handlePaymentMethodChange = () => {
    paymentRemark.value = '';
  };

  const resetFoodTicketEmployee = () => {
    foodTicketEmployeeNo.value = '';
    foodTicketCustomer.value = null;
  };

  const validateFoodTicketEmployee = async (): Promise<boolean> => {
    const employeeNo = foodTicketEmployeeNo.value.trim();
    if (!/^\d+$/.test(employeeNo)) {
      showToast('请输入正确的员工工号');
      return false;
    }

    const customerId = Number(employeeNo);
    if (!Number.isSafeInteger(customerId) || customerId <= 0) {
      showToast('请输入正确的员工工号');
      return false;
    }

    isValidatingEmployee.value = true;
    try {
      const response = await getCustomerList({
        pageNum: 1,
        pageSize: 10,
        data: { customerId, type: 1, status: 0 },
      });
      if (response.code !== 200) {
        showToast(response.msg || '员工信息查询失败');
        return false;
      }

      const matchedCustomers = (response.result?.list || []).filter(
        (customer) =>
          customer.customerId === customerId &&
          customer.type === 1 &&
          customer.status === 0 &&
          customer.disabled === 0,
      );
      if (matchedCustomers.length === 0) {
        showToast('未查询到可用的员工信息');
        return false;
      }
      if (matchedCustomers.length > 1) {
        showToast('员工工号重复，请联系管理员');
        return false;
      }

      foodTicketCustomer.value = matchedCustomers[0];
      foodTicketEmployeeNo.value = String(matchedCustomers[0].customerId);
      return true;
    } catch (error) {
      console.error('查询员工信息失败:', error);
      showToast('员工信息查询失败，请稍后重试');
      return false;
    } finally {
      isValidatingEmployee.value = false;
    }
  };

  const hidePaymentConfirmModal = () => {
    paymentConfirmModalVisible.value = false;
    // 如果有B扫C收款选项，默认选择B扫C收款，否则选择POS支付
    selectedPaymentMethod.value = isOnlinePayment.value ? 3 : 4;
    paymentRemark.value = '';
  };

  const cancelPaymentConfirmation = () => {
    hidePaymentConfirmModal();
    if (currentOrderId.value) {
      showToast('订单已创建，可点击“继续支付”重新发起支付');
    }
  };

  const handleSubmittedOrderFailure = async (message: string) => {
    hidePaymentConfirmModal();
    await showDialog({
      title: '订单已创建',
      message: `${message}\n\n订单已经创建，请前往桌位管理查看或继续处理，请勿重复下单。`,
    });
    router.replace('/tableManage');
  };

  // 处理支付确认（根据支付方式选择不同的处理逻辑）
  const handlePaymentConfirm = async () => {
    if (selectedPaymentMethod.value === 100) {
      if (unsupportedFoodTicketNames.value.length > 0) {
        const foodNames = unsupportedFoodTicketNames.value.join('、');
        if (!hasPendingPayment.value) {
          hidePaymentConfirmModal();
        }
        await showDialog({
          title: '菜品不支持餐券',
          message: hasPendingPayment.value
            ? `以下菜品不支持餐券使用：${foodNames}。订单已创建，请选择其他支付方式。`
            : `以下菜品不支持餐券使用：${foodNames}。请删除后再使用餐券支付。`,
        });
        return;
      }
      if (hasPendingPayment.value && !foodTicketCustomer.value) {
        showToast('该订单未绑定员工，不能改用餐券支付');
        return;
      }
      if (!foodTicketCustomer.value && !(await validateFoodTicketEmployee())) {
        return;
      }
      if (!hasEnoughFoodTicketBalance.value) {
        showToast('员工餐券余额不足，请选择其他支付方式');
        return;
      }
    }

    if (!currentOrderId.value && !(await createOrder())) {
      return;
    }

    if (selectedPaymentMethod.value === 3) {
      // B扫C收款，显示扫码界面
      hidePaymentConfirmModal();
      showScanPaymentModal();
    } else {
      // 其他支付方式，直接确认支付
      confirmPayment();
    }
  };

  // 处理支付完成后的逻辑（判断tableOrderCompleteType并调用相应接口）
  const handleAfterPayment = async () => {
    // 如果tableOrderCompleteType等于1，先调用全部出餐接口，然后调用核销接口
    if (tableOrderCompleteType.value === 1 && currentOrderId.value && shopId.value) {
      try {
        // 先调用全部出餐接口
        const foodUpResponse = await foodUp({
          orderId: currentOrderId.value,
          shopId: shopId.value,
        });
        if (foodUpResponse.code === 200) {
          // 全部出餐接口成功后，调用核销接口
          const completeResponse = await completeOrder({ orderId: currentOrderId.value });
          if (completeResponse.code === 200) {
            console.log('全部出餐并核销成功');
          } else {
            console.warn('核销失败:', completeResponse.msg || '接口返回错误');
          }
        } else {
          console.warn('全部出餐失败:', foodUpResponse.msg || '接口返回错误');
        }
      } catch (error) {
        console.error('处理支付后逻辑异常:', error);
      }
    }
  };

  // 确认支付（线下支付方式）
  const confirmPayment = async () => {
    try {
      if (!currentOrderId.value) {
        showDialog({ message: '订单信息不完整，无法确认支付' });
        return;
      }

      const employeeName = getEmployeeName();
      let remark = '';
      let paymentMethodName = '';

      // 根据选择的支付方式设置备注和支付方式名称
      if (selectedPaymentMethod.value === 3) {
        paymentMethodName = 'B扫C收款';
        remark = `服务员${employeeName}确认B扫C收款完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 4) {
        paymentMethodName = 'POS支付';
        remark = `服务员${employeeName}确认POS支付完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 5) {
        paymentMethodName = '公司挂账';
        remark = `服务员${employeeName}确认挂账，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 7) {
        paymentMethodName = '现金支付';
        remark = `服务员${employeeName}确认现金支付完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 100) {
        paymentMethodName = '餐券';
        remark = `服务员${employeeName}使用员工${foodTicketCustomer.value?.customerName}（工号${
          foodTicketCustomer.value?.customerId
        }）餐券支付，${paymentRemark.value || ''}`;
      }

      const paymentData: OrderPaymentModel = {
        orderId: currentOrderId.value,
        paymentMethod: selectedPaymentMethod.value,
        paymentMethodName: paymentMethodName,
        paymentStatus: 1, // 已支付
        amount: total.value,
        paymentTime: dateTimeFormat(dayjs()),
        remark: remark.trim(),
      };

      const response = await insertOrderPayment(paymentData);
      if (response.code === 200 && response.result.paymentStatus === 1) {
        hidePaymentConfirmModal();
        // 处理支付完成后的逻辑
        await handleAfterPayment();
        showDialog({
          message: `${tableName.value}${paymentMethodName}已确认完成！\n总金额：¥${total.value}\n共${totalCount.value}份菜品`,
        });
        // 延迟跳转，让用户看到成功提示
        setTimeout(() => {
          router.push('/tableManage');
        }, 1500);
      } else if (response.code === 200) {
        await showDialog({
          title: '支付失败',
          message:
            selectedPaymentMethod.value === 100
              ? '餐券扣款失败，请核对员工餐券余额后重试，或选择其他支付方式。'
              : '支付未成功，请核对后重试。',
        });
      } else {
        await handleSubmittedOrderFailure(response.msg || '支付或打印处理失败');
      }
    } catch (error) {
      console.error('确认支付失败:', error);
      await handleSubmittedOrderFailure('支付或打印处理失败，请稍后核对订单状态');
    }
  };

  // 显示扫码支付全屏界面
  const showScanPaymentModal = async () => {
    scanPaymentModalVisible.value = true;
    scanPaymentRemark.value = '';
    scanStatus.value = '';
    // 立即设置为扫描中，避免显示"正在启动摄像头"提示
    isScanning.value = true;

    // 自动开始扫描
    await nextTick();
    getCamerasInfo();
  };

  // 隐藏扫码支付全屏界面
  const hideScanPaymentModal = () => {
    stopScan();
    scanPaymentModalVisible.value = false;
    scanPaymentRemark.value = '';
    scanStatus.value = '';
  };

  // 用户主动退出扫码时返回支付方式选择，继续复用已创建的订单。
  const cancelScanPayment = () => {
    hideScanPaymentModal();
    showPaymentConfirmModal();
    showToast('订单已创建，请继续完成支付');
  };

  // 获取摄像头信息并初始化
  const getCamerasInfo = () => {
    // 立即设置为扫描中，隐藏"正在启动摄像头"提示
    isScanning.value = true;

    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          html5QrCode = new Html5Qrcode('qr-reader');
          startScan();
        } else {
          // 没有可用摄像头
          isScanning.value = false;
          scanStatus.value = '未检测到摄像头设备';
          scanStatusClass.value = 'bg-red-100 text-red-700';
        }
      })
      .catch((err) => {
        console.error('获取摄像头失败:', err);
        scanStatus.value = '摄像头无访问权限！';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 开始扫描
  const startScan = () => {
    if (!html5QrCode) {
      console.error('html5QrCode 未初始化');
      return;
    }

    isScanning.value = true;
    scanStatus.value = '';
    scanStatusClass.value = '';

    html5QrCode
      .start(
        { facingMode: 'environment' },
        {
          fps: 20,
          // 全屏扫码：使用整个视窗大小
          qrbox: function (viewfinderWidth, viewfinderHeight) {
            return {
              width: viewfinderWidth,
              height: viewfinderHeight,
            };
          },
          // 不限制宽高比，允许全屏显示
          aspectRatio: undefined,
        },
        (decodedText, decodedResult) => {
          // 扫码成功回调
          handleScanResult(decodedText);
        },
      )
      .then(() => {
        // 扫描启动成功后，强制应用全屏样式
        nextTick(() => {
          forceFullscreenStyles();
        });
      })
      .catch((err) => {
        console.error('扫码失败', err);
        scanStatus.value = '启动摄像头失败，请检查权限设置';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 强制应用全屏样式
  const forceFullscreenStyles = () => {
    const qrReader = document.getElementById('qr-reader');
    if (!qrReader) return;

    // 强制设置容器样式
    const container = qrReader.querySelector('#html5qr-container');
    if (container) {
      (container as HTMLElement).style.width = '100%';
      (container as HTMLElement).style.height = '100%';
      (container as HTMLElement).style.minWidth = '100%';
      (container as HTMLElement).style.minHeight = '100%';
    }

    // 强制设置视频样式
    const videos = qrReader.querySelectorAll('video');
    videos.forEach((video) => {
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.minWidth = '100%';
      video.style.minHeight = '100%';
      video.style.objectFit = 'cover';
      video.style.position = 'absolute';
      video.style.top = '0';
      video.style.left = '0';
      video.style.right = '0';
      video.style.bottom = '0';
    });

    // 强制设置画布样式
    const canvases = qrReader.querySelectorAll('canvas');
    canvases.forEach((canvas) => {
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.minWidth = '100%';
      canvas.style.minHeight = '100%';
      canvas.style.objectFit = 'cover';
      canvas.style.position = 'absolute';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.right = '0';
      canvas.style.bottom = '0';
    });
  };

  // 停止扫描
  const stopScan = () => {
    if (html5QrCode && html5QrCode.isScanning) {
      html5QrCode
        .stop()
        .then(() => {
          html5QrCode?.clear();
          isScanning.value = false;
        })
        .catch((err) => {
          console.error('停止扫描失败:', err);
          isScanning.value = false;
        });
    } else {
      isScanning.value = false;
    }
  };

  // 处理扫描结果
  const handleScanResult = async (scanCode: string) => {
    // 验证扫码结果
    if (!scanCode || scanCode.trim() === '') {
      return;
    }

    // 停止扫描，但保持界面打开
    stopScan();

    // 显示处理中状态
    scanStatus.value = '扫码成功，正在处理支付...';
    scanStatusClass.value = 'bg-blue-100 text-blue-700';

    // 调用支付接口
    await submitScanPayment(scanCode);
  };

  // 提交扫码支付
  const submitScanPayment = async (scanCode: string) => {
    try {
      if (!currentOrderId.value) {
        scanStatus.value = '订单信息不完整，无法支付';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        showDialog({ message: '订单信息不完整，无法支付' });
        return;
      }

      // 获取IP地址（简化处理，实际可以从服务器获取）
      const ip = await getClientIP();

      // 构建支付数据
      const paymentData = {
        orderId: currentOrderId.value,
        scanCode: scanCode,
        remark: scanPaymentRemark.value || '',
        ip: ip || '',
        amount: total.value,
      };

      // 调用扫码支付接口
      const response = await scanPayment(paymentData);

      // 根据接口返回结果处理
      if (response.code === 200) {
        // API 返回 200，立即关闭扫码界面
        hideScanPaymentModal();

        // 根据业务结果在详情界面显示提示
        if (response.result?.success) {
          // 支付成功
          // 处理支付完成后的逻辑
          await handleAfterPayment();
          showDialog({
            message: `扫码支付成功！\n总金额：¥${total.value}\n共${totalCount.value}份菜品`,
          });
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            router.push('/tableManage');
          }, 1500);
        } else {
          // 支付失败，显示确认模态框
          scanPaymentFailErrorMsg.value = response.result?.errorMsg || '';
          scanPaymentFailModalVisible.value = true;
        }
      } else {
        // API 返回非 200，支付结果可能不明确，交由服务员选择查询或重新扫码
        const errorMsg = response.msg || '支付失败，请重试';
        hideScanPaymentModal();
        scanPaymentFailErrorMsg.value = errorMsg;
        scanPaymentFailModalVisible.value = true;
      }
    } catch (error) {
      console.error('扫码支付失败:', error);

      // 网络异常时支付结果也可能不明确，交由服务员选择查询或重新扫码
      hideScanPaymentModal();
      scanPaymentFailErrorMsg.value = '支付失败，请稍后重试';
      scanPaymentFailModalVisible.value = true;
    }
  };

  // 获取客户端IP地址（简化版本）
  const getClientIP = async (): Promise<string> => {
    // 可以调用后端接口获取真实IP，这里先返回空字符串
    // 或者使用第三方服务获取IP
    return '';
  };

  // 确认已经支付（刷新扫码支付状态）
  const confirmScanPaymentPaid = async () => {
    // 防抖：如果正在刷新，直接返回
    if (isRefreshingPayment.value) {
      return;
    }

    try {
      if (!currentOrderId.value) {
        showDialog({ message: '订单信息不完整，无法确认支付' });
        return;
      }

      // 设置 loading 状态
      isRefreshingPayment.value = true;

      const response = await refreshScanPayment({
        orderId: currentOrderId.value,
      });

      if (response.code === 200) {
        // 根据业务结果处理
        if (response.result?.success) {
          // 支付成功，关闭模态框
          scanPaymentFailModalVisible.value = false;
          scanPaymentFailErrorMsg.value = '';
          // 处理支付完成后的逻辑
          await handleAfterPayment();
          showDialog({
            message: `支付成功！\n总金额：¥${total.value}\n共${totalCount.value}份菜品`,
          });
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            router.push('/tableManage');
          }, 1500);
        } else {
          // 支付失败，显示错误信息，模态框不关闭
          const errorMsg = response.result?.errorMsg || '刷新支付状态失败，请重试';
          scanPaymentFailErrorMsg.value = errorMsg;
          showDialog({ message: errorMsg });
        }
      } else {
        // API 返回非 200，显示错误信息，模态框不关闭
        const errorMsg = response.msg || '刷新支付状态失败，请稍后重试';
        scanPaymentFailErrorMsg.value = errorMsg;
        showDialog({ message: errorMsg });
      }
    } catch (error) {
      console.error('刷新支付状态失败:', error);
      const errorMsg = '刷新支付状态失败，请稍后重试';
      scanPaymentFailErrorMsg.value = errorMsg;
      showDialog({ message: errorMsg });
    } finally {
      // 无论成功失败，都要重置 loading 状态
      isRefreshingPayment.value = false;
    }
  };

  // 确认未支付后重新扫码，重新发起扫码支付
  const retryScanPayment = async () => {
    scanPaymentFailModalVisible.value = false;
    scanPaymentFailErrorMsg.value = '';
    await showScanPaymentModal();
  };

  // 取消确认支付
  const cancelScanPaymentConfirm = () => {
    scanPaymentFailModalVisible.value = false;
    scanPaymentFailErrorMsg.value = '';
    isRefreshingPayment.value = false; // 重置 loading 状态
    showPaymentConfirmModal();
  };

  const confirmDiscount = () => {
    if (
      tempDiscountMode.value === 'amount' &&
      (tempManualDiscountAmount.value < 0 || tempManualDiscountAmount.value > subtotal.value)
    ) {
      showToast('折扣金额必须在0和订单小计之间');
      return;
    }
    discountMode.value = tempDiscountMode.value;
    manualDiscountAmount.value = tempManualDiscountAmount.value;
    discountRate.value = tempDiscountRate.value;
    discountModalVisible.value = false;
  };

  const showSpecDialog = (item: any, event?: Event) => {
    if (hasPendingPayment.value) {
      showToast('订单已创建，支付完成前不能修改菜品');
      return;
    }
    if ((item.stockQuantity ?? 0) <= 0) {
      showToast('该菜品库存不足，暂时无法添加');
      return;
    }
    if (!item.specs || item.specs.length === 0) {
      showToast('该菜品未配置规格，暂时无法添加');
      return;
    }
    console.log('=== showSpecDialog 调试信息 ===');
    console.log('当前菜品:', item.name);
    console.log('cookList:', item.cookList);
    console.log('cookList长度:', item.cookList?.length);

    currentFood.value = item;
    // 设置默认规格（第一个规格）
    selectedSpec.value = item.specs[0];

    // 从item.cookList动态获取做法选项
    if (item.cookList && item.cookList.length > 0) {
      console.log('开始解析cookList...');
      methods.value = [];

      item.cookList.forEach((cook: any, cookIndex: number) => {
        console.log(`处理第${cookIndex + 1}个cook:`, cook);
        console.log('cookValue:', cook.cookValue);
        console.log('valueList:', cook.valueList);

        // 解析cookValue JSON字符串
        let cookValues = [];
        try {
          if (cook.cookValue) {
            cookValues = JSON.parse(cook.cookValue);
            console.log('解析cookValue成功:', cookValues);
          } else if (cook.valueList && cook.valueList.length > 0) {
            // 如果cookValue为空，使用valueList
            cookValues = cook.valueList;
            console.log('使用valueList:', cookValues);
          }
        } catch (error) {
          console.error('解析cookValue失败:', error);
          // 如果解析失败，使用valueList作为备用
          if (cook.valueList && cook.valueList.length > 0) {
            cookValues = cook.valueList;
            console.log('解析失败，使用valueList备用:', cookValues);
          }
        }

        // 将解析出的值添加到methods中，包含属性名称
        cookValues.forEach((valueItem: any, valueIndex: number) => {
          const value = valueItem.value || valueItem;
          const methodItem = {
            id: cook.cookId * 1000 + valueIndex, // 使用cookId * 1000 + valueIndex作为唯一ID
            name: value,
            cookId: cook.cookId,
            cookName: cook.cookName, // 属性名称，如"做法"、"配菜"
            cookType: cook.cookType,
            attributeName: cook.cookName, // 添加属性名称字段
          };
          methods.value.push(methodItem);
          console.log('添加做法选项:', methodItem);
        });
      });

      console.log('最终methods数组:', methods.value);
      // 设置默认选择第一个做法
      // 默认不选择任何做法
      selectedMethod.value = 0;

      // 初始化每个属性的默认选择
      selectedMethods.value = {};
      // 默认不选任何做法（包括常规），无需初始化条目
    } else {
      console.log('没有cookList，使用默认做法（不默认选中）');
      // 如果没有cookList，提供一个"常规"选项，但不默认选中
      methods.value = [{ id: 0, name: '常规' }];
      selectedMethod.value = 0;
      selectedMethods.value = {};
    }

    currentEvent.value = event; // 保存原始点击事件

    // 如果有做法选择，或者有多个规格，都需要弹窗
    if ((item.cookList && item.cookList.length > 0) || (item.specs && item.specs.length > 1)) {
      showSpecModalVisible.value = true;
    } else {
      // 没有做法且只有一个规格，直接添加到订单
      addToOrderWithSpec(item, event);
    }
  };

  const hideSpecModal = () => {
    showSpecModalVisible.value = false;
    currentFood.value = {};
    selectedSpec.value = {};
    selectedMethod.value = 0;
    selectedMethods.value = {}; // 清空多属性选择
    methods.value = []; // 清空做法列表
    currentEvent.value = undefined; // 清空原始点击事件
  };

  // 新增：切换做法选择（支持多选）
  const toggleMethodSelection = (attributeName: string, methodId: number) => {
    // 找到对应的cookType
    const method = methods.value.find((m) => m.id === methodId);
    const cookType = method?.cookType || 1; // 默认为多选

    if (cookType === 2) {
      // 单选：直接替换选择
      selectedMethods.value[attributeName] = methodId;
    } else {
      // 多选：支持多个选择
      if (!selectedMethods.value[attributeName]) {
        // 如果该属性还没有选择，初始化为数组
        selectedMethods.value[attributeName] = [methodId];
      } else if (Array.isArray(selectedMethods.value[attributeName])) {
        // 如果已经是数组，切换选择状态
        const currentSelection = selectedMethods.value[attributeName] as number[];
        const index = currentSelection.indexOf(methodId);
        if (index > -1) {
          // 如果已选中，则取消选择
          currentSelection.splice(index, 1);
          // 如果数组为空，删除该属性
          if (currentSelection.length === 0) {
            delete selectedMethods.value[attributeName];
          }
        } else {
          // 如果未选中，则添加选择
          currentSelection.push(methodId);
        }
      } else {
        // 如果之前是单选，转换为多选
        const currentId = selectedMethods.value[attributeName] as number;
        if (currentId === methodId) {
          // 如果点击的是已选中的，则取消选择
          delete selectedMethods.value[attributeName];
        } else {
          // 否则转换为多选
          selectedMethods.value[attributeName] = [currentId, methodId];
        }
      }
    }
  };

  // 新增：检查做法是否被选中
  const isMethodSelected = (attributeName: string, methodId: number): boolean => {
    const selection = selectedMethods.value[attributeName];
    // 找到对应的cookType
    const method = methods.value.find((m) => m.id === methodId);
    const cookType = method?.cookType || 1; // 默认为多选

    if (cookType === 2) {
      // 单选：直接比较
      return selection === methodId;
    } else {
      // 多选：检查是否在数组中
      if (Array.isArray(selection)) {
        return selection.includes(methodId);
      }
      return selection === methodId;
    }
  };

  const confirmAddToOrder = () => {
    if (hasPendingPayment.value) {
      hideSpecModal();
      showToast('订单已创建，支付完成前不能修改菜品');
      return;
    }
    console.log('=== 开始确认添加流程 ===');

    // 添加到订单
    addToOrderWithSpec(currentFood.value, currentEvent.value);

    // 立即开始动画，不等待DOM更新
    setTimeout(() => {
      flyFromSpecModal();
    }, 10);

    // 延长弹窗关闭时间，确保动画可见
    setTimeout(() => {
      hideSpecModal();
    }, 800);
  };

  const flyFromSpecModal = () => {
    console.log('=== 开始飞入动画 ===');
    console.log('当前菜品:', currentFood.value.name);

    // 直接查找当前显示的规格弹窗
    const specModal =
      document.querySelector('[data-modal="spec-modal"]') ||
      document.querySelector('.fixed.inset-0.bg-black.bg-opacity-50:last-child');

    if (!specModal) {
      console.log('❌ 未找到规格弹窗');
      // 尝试备用方案
      const allModals = document.querySelectorAll('.fixed.inset-0.bg-black.bg-opacity-50');
      console.log('找到的所有弹窗:', allModals.length);
      if (allModals.length > 0) {
        const lastModal = allModals[allModals.length - 1];
        console.log('使用最后一个弹窗:', lastModal);
        startAnimation(lastModal);
      }
      return;
    }

    console.log('✅ 找到规格弹窗');
    startAnimation(specModal);
  };

  const startAnimation = (modal: Element) => {
    const img = modal.querySelector('img');
    if (!img) {
      console.log('❌ 未找到图片元素');
      return;
    }
    console.log('✅ 找到图片元素');

    if (!orderPanel.value) {
      console.log('❌ 未找到订单面板');
      return;
    }
    console.log('✅ 找到订单面板');

    const imgRect = img.getBoundingClientRect();
    const orderRect = orderPanel.value.getBoundingClientRect();

    console.log('图片位置:', {
      x: imgRect.left,
      y: imgRect.top,
      w: imgRect.width,
      h: imgRect.height,
    });
    console.log('订单面板位置:', {
      x: orderRect.left,
      y: orderRect.top,
      w: orderRect.width,
      h: orderRect.height,
    });

    // 确保图片有有效的位置信息
    if (imgRect.width === 0 || imgRect.height === 0) {
      console.log('❌ 图片尺寸无效');
      return;
    }

    // 创建克隆图片
    const clone = img.cloneNode(true) as HTMLImageElement;
    clone.style.position = 'fixed';
    clone.style.left = imgRect.left + 'px';
    clone.style.top = imgRect.top + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    clone.style.zIndex = '10000';
    clone.style.borderRadius = '8px';
    clone.style.boxShadow = '0 8px 24px rgba(0,0,0,0.5)';
    clone.style.transition = 'all 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    clone.style.pointerEvents = 'none';
    clone.style.opacity = '1';
    clone.style.border = '3px solid #10b981';
    document.body.appendChild(clone);
    console.log('✅ 克隆图片已添加');

    // 计算目标位置
    const targetX = orderRect.left + orderRect.width / 2 - imgRect.width / 2;
    const targetY = orderRect.top + 50;

    console.log('目标位置:', { x: targetX, y: targetY });

    // 开始动画
    setTimeout(() => {
      clone.style.transform = `translate(${targetX - imgRect.left}px, ${
        targetY - imgRect.top
      }px) scale(0.2)`;
      clone.style.opacity = '0.3';
      console.log('🚀 动画已开始');
    }, 100);

    // 清理
    setTimeout(() => {
      if (clone.parentNode) {
        clone.parentNode.removeChild(clone);
        console.log('🧹 动画完成，已清理');
      }
    }, 1600);
  };

  const addToOrderWithSpec = (item: any, event?: Event) => {
    if (hasPendingPayment.value) return;
    if ((item.stockQuantity ?? 0) <= 0) {
      showToast('该菜品库存不足，暂时无法添加');
      return;
    }
    if (!item.specs || item.specs.length === 0) {
      showToast('该菜品未配置规格，暂时无法添加');
      return;
    }
    // 使用选中的规格信息
    const specInfo = selectedSpec.value;
    if (!specInfo.id || specInfo.id <= 0) {
      showToast('该菜品规格配置异常，暂时无法添加');
      return;
    }

    // 生成组合的methodName，包含所有选择的属性（支持多选）
    const methodNames: string[] = [];
    // 按照methods数组的显示顺序来构建methodName
    const attributeGroups: { [key: string]: string[] } = {};

    // 先收集所有选中的做法，按属性分组
    Object.keys(selectedMethods.value).forEach((attributeName) => {
      const selectedIds = selectedMethods.value[attributeName];
      if (Array.isArray(selectedIds)) {
        // 多选：收集选中的做法名称
        const selectedMethodNames = selectedIds
          .map((id) => {
            const method = methods.value.find((m) => m.id === id);
            return method ? method.name : '';
          })
          .filter((name) => name); // 过滤掉空值

        if (selectedMethodNames.length > 0) {
          attributeGroups[attributeName] = selectedMethodNames;
        }
      } else if (selectedIds) {
        // 单选：收集选中的做法名称
        const method = methods.value.find((m) => m.id === selectedIds);
        if (method) {
          attributeGroups[attributeName] = [method.name];
        }
      }
    });

    // 按照methods数组中的显示顺序来构建最终的methodName
    methods.value.forEach((method) => {
      const attributeName = method.attributeName || method.cookName || '做法';
      if (attributeGroups[attributeName] && attributeGroups[attributeName].includes(method.name)) {
        // 如果这个做法被选中了，添加到结果中
        if (!methodNames.includes(`${attributeName}:${method.name}`)) {
          methodNames.push(`${attributeName}:${method.name}`);
        }
      }
    });

    // 按照属性分组重新组织显示格式
    const groupedMethods: { [key: string]: string[] } = {};

    // 将选中的做法按属性分组
    methodNames.forEach((methodName) => {
      const [attributeName, methodValue] = methodName.split(':');
      if (!groupedMethods[attributeName]) {
        groupedMethods[attributeName] = [];
      }
      groupedMethods[attributeName].push(methodValue);
    });

    // 按照属性分组构建最终的显示文本
    const finalMethodNames: string[] = [];
    Object.keys(groupedMethods).forEach((attributeName) => {
      const methods = groupedMethods[attributeName];
      if (methods.length > 0) {
        finalMethodNames.push(`${attributeName}：${methods.join('，')}`);
      }
    });

    const combinedMethodName = finalMethodNames.join('，');

    const orderItem = {
      ...item,
      price: specInfo.price || item.price,
      shopFoodSpecId: specInfo.id,
      specName: specInfo.name || '标准',
      methodId: selectedMethod.value,
      methodName: combinedMethodName,
    };

    // 1. 订单逻辑
    const found = orderItems.value.find(
      (o) => o.id === item.id && o.shopFoodSpecId === orderItem.shopFoodSpecId,
    );
    if (found) {
      found.quantity += 1;
    } else {
      orderItems.value.push({
        ...orderItem,
        quantity: 1,
        shopFoodSpecId: orderItem.shopFoodSpecId,
      });
    }

    // 2. 动画效果 - 只有在直接点击菜品时才播放flyToOrder动画
    // 如果是从规格弹窗确认添加，则不播放这个动画（会由flyFromSpecModal处理）
    if (event && !showSpecModalVisible.value) {
      nextTick(() => {
        flyToOrder(event);
      });
    }

    console.log('添加到订单:', orderItem);
  };

  const loadShopDetailAndBusinessTime = async () => {
    try {
      const response = await fetchShopDetail({ shopId: shopId.value });
      if (response.code === 200) {
        shopDetail.value = response.result;
        businessTimeList.value = response.result.businessTimeList || [];
        // 判断支付方式：0线下、1线上
        isOnlinePayment.value = response.result.paymentLine === 1;
        // 如果有B扫C收款选项，默认选择B扫C收款
        if (isOnlinePayment.value) {
          selectedPaymentMethod.value = 3;
        }
      } else {
        showDialog({ message: response.msg || '加载店铺详情失败' });
      }
    } catch (error) {
      showDialog({ message: '加载店铺详情失败，请稍后重试' });
    }
  };

  const loadFoodTicketConfig = async () => {
    try {
      const response = await getShopConfigList({
        pageNum: 1,
        pageSize: 100,
        data: { configStatus: 0, configType: 1, shopId: shopId.value },
      });
      foodTicketEnabled.value =
        response.code === 200 &&
        (response.result?.list || []).some(
          (config) => config.configStatus === 0 && config.configKey === 100,
        );
    } catch (error) {
      console.error('加载餐券支付配置失败:', error);
      foodTicketEnabled.value = false;
    }
  };

  // 检查当前时间是否在营业时间内
  const checkBusinessTime = async (): Promise<boolean> => {
    // 如果没有营业时间配置，默认允许操作
    if (!businessTimeList.value || businessTimeList.value.length === 0) {
      return true;
    }

    const now = new Date();
    const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(
      now.getMinutes(),
    ).padStart(2, '0')}`;

    // 检查是否在任何一个营业时间段内
    const isInBusinessTime = businessTimeList.value.some((timeSlot) => {
      return currentTime >= timeSlot.beginTime && currentTime <= timeSlot.endTime;
    });

    if (isInBusinessTime) {
      return true;
    }

    // 不在营业时间内，显示确认对话框
    const timeSlots = businessTimeList.value
      .map((slot) => `${slot.beginTime}-${slot.endTime}`)
      .join('、');

    confirmMessage.value = `当前时间 ${currentTime} 不在营业时间内。\n\n营业时间：${timeSlots}\n\n确定要继续下单吗？`;
    confirmTitle.value = '营业时间提醒';
    const result = await confirmDialog.value?.show();
    return result || false;
  };

  const loadAvailableTimeList = async () => {
    if (!isSpecialOrder.value) return;

    try {
      let response;
      if (dineType.value === 5) {
        const shopFoodIds = [...new Set(orderItems.value.map((item) => item.id))];
        response = await getBookTimeList({ shopId: shopId.value, shopFoodIds });
      } else if (dineType.value === 3) {
        response = await getDeliveryTimeList({ shopId: shopId.value });
      } else {
        response = await getSelfPickTimeList({ shopId: shopId.value });
      }

      const list = response.code === 200 && Array.isArray(response.result) ? response.result : [];
      const timeMap: Record<string, string[]> = {};
      const dates: string[] = [];

      list.forEach((item) => {
        if (!item.selfPickDate) return;
        dates.push(item.selfPickDate);
        timeMap[item.selfPickDate] = (item.selfPickTimeList || [])
          .map((timeItem) => timeItem.selfPickTime)
          .filter((time): time is string => Boolean(time));
      });

      availableDates.value = dates;
      availableTimeMap.value = timeMap;
      selectedPickerDate.value = dates[0] || '';

      if (dates.length === 0) {
        showToast(`暂无可选${timeLabel.value}`);
      }
    } catch (error) {
      console.error(`加载${timeLabel.value}失败:`, error);
      availableDates.value = [];
      availableTimeMap.value = {};
      selectedPickerDate.value = '';
      showToast(`${timeLabel.value}加载失败，请稍后重试`);
    }
  };

  const showTimePicker = async () => {
    if (dineType.value === 5) {
      await loadAvailableTimeList();
    }
    if (availableDates.value.length === 0) {
      showToast(`暂无可选${timeLabel.value}`);
      return;
    }
    selectedPickerDate.value = selfPickDate.value || availableDates.value[0];
    const availableTimes = availableTimeMap.value[selectedPickerDate.value] || [];
    const selectedTime = availableTimes.includes(selfPickTime.value)
      ? selfPickTime.value
      : availableTimes[0] || '';
    timePickerValues.value = [selectedPickerDate.value, selectedTime];
    timePickerVisible.value = true;
  };

  const handleTimePickerChange = ({ selectedValues, columnIndex }: PickerChangeEventParams) => {
    if (columnIndex !== 0) return;

    const selectedDate = String(selectedValues[0] || '');
    if (selectedDate && selectedDate !== selectedPickerDate.value) {
      selectedPickerDate.value = selectedDate;
      timePickerValues.value = [selectedDate, availableTimeMap.value[selectedDate]?.[0] || ''];
    }
  };

  const handleTimePickerConfirm = ({ selectedValues }: PickerConfirmEventParams) => {
    const selectedDate = String(selectedValues[0] || '');
    const selectedTime = String(selectedValues[1] || '');
    if (!selectedDate || !selectedTime) {
      showToast(`请选择完整的${timeLabel.value}`);
      return;
    }
    selfPickDate.value = selectedDate;
    selfPickTime.value = selectedTime;
    timePickerVisible.value = false;
  };

  onMounted(() => {
    // 设置当前时间
    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')} ${now
      .getHours()
      .toString()
      .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
    currentTime.value = formattedDate;
    tableNumber.value = Number(route.query.tableNumber) || 0;
    tableName.value = (route.query.tableName as string) || '';
    tableTag.value = typeof route.query.tableTag === 'string' ? route.query.tableTag : '';
    shopId.value = Number(route.query.shopId) || 0;
    shopName.value = (route.query.shopName as string) || '';
    cartType.value = Number(route.query.cartType) || 1;
    loadAllCategories();
    loadShopDetailAndBusinessTime();
    loadFoodTicketConfig();
    loadAvailableTimeList();
  });

  const loadAllCategories = async () => {
    try {
      const [categoryTagResp, foodResp] = await Promise.all([
        fetchCategoryTagList({
          // 新接口不分页，只按店铺查询分类+标签
          shopId: shopId.value,
        }),
        fetchCategoryItemList({
          pageNum: 1,
          pageSize: 999,
          data: { shopId: shopId.value, shopFoodStatus: 0 },
        }),
      ]);

      if (categoryTagResp.code === 200 && foodResp.code === 200) {
        // 新接口不分页，后端直接返回数组；为兼容性，这里同时兼容老的 result.list 结构
        const categoryTagResult: any = categoryTagResp.result;
        const categoryTagList: any[] = Array.isArray(categoryTagResult)
          ? categoryTagResult
          : categoryTagResult?.list || [];
        const foodList: any[] = foodResp.result?.list || [];

        console.log('=== 分类+标签及菜品调试 ===');
        console.log('分类/标签列表:', categoryTagList);
        console.log('菜品列表原始数据:', foodList);
        if (foodList.length > 0) {
          console.log('第一个菜品数据:', foodList[0]);
          console.log('第一个菜品的cookList:', foodList[0]?.cookList);
        }

        // 先构建所有菜品的完整列表
        const allItems: Array<CategoryItemModel> = [];
        foodList.forEach((item: any) => {
          const specItems: Array<{
            id: number;
            name: string;
            price: number;
            specId: number;
            specName: string;
          }> = [];
          (item.specList || []).forEach((specItem: any) => {
            specItems.push({
              id: specItem.shopFoodSpecId,
              name: specItem.specName,
              price: specItem.price,
              specId: specItem.specId,
              specName: specItem.specName,
            });
          });
          allItems.push({
            id: item.shopFoodId,
            name: item.shopFoodName,
            foodId: item.foodId,
            foodName: item.foodName,
            shopFoodStatus: item.shopFoodStatus,
            isFoodTicket: item.isFoodTicket,
            price: item.price,
            description: item.shopFoodDesc,
            foodType: item.foodType,
            image: item.imageUrl,
            stockQuantity: item.stockQuantity ?? 0,
            specs: specItems,
            shopFoodSpecId: specItems.length > 0 ? specItems[0].id : undefined,
            cookList: item.cookList || [],
          });
        });
        const menuFoodIds = new Set(
          foodList
            .filter((item: any) => {
              const tags = String(item.tags || '')
                .split(',')
                .map((tag) => tag.trim())
                .filter(Boolean);
              return tags.includes(menuTag.value);
            })
            .map((item: any) => item.shopFoodId),
        );
        const shouldFilterByMenuTag = menuFoodIds.size > 0;

        allMenuItems.value = shouldFilterByMenuTag
          ? allItems.filter((item) => item.id !== undefined && menuFoodIds.has(item.id))
          : allItems;

        // 桌号类型直接与菜品 tags 匹配，不依赖分类或推荐标签配置。
        const visibleCategoryTagList = shouldFilterByMenuTag
          ? [{ id: 0, name: menuTag.value, type: 1 }]
          : categoryTagList;

        categories.value = [
          {
            id: 0,
            name: '全部',
            items: allMenuItems.value,
          },
        ];

        // 根据返回的 type 构建分类：
        // type = 1 -> 标签：按菜品的 tags 字段模糊匹配
        // type = 2 -> 分类：按原来的分类匹配逻辑（shopFoodCategoryId === id）
        visibleCategoryTagList.forEach((ct: any) => {
          const ctId = ct.id;
          const ctName = ct.name;
          const ctType = ct.type; // 1=标签，2=分类

          let itemList: any[] = [];
          if (ctType === 2) {
            // 分类：按分类ID匹配
            itemList = foodList.filter((item: any) => item.shopFoodCategoryId === ctId);
          } else if (ctType === 1) {
            // 标签：按 tags 字段模糊匹配
            itemList = foodList.filter((item: any) => {
              const tagsStr = String(item.tags || '');
              return tagsStr
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
                .includes(String(ctName || '').trim());
            });
          } else {
            // 其他类型暂不处理
            return;
          }

          // 当前分类/标签下的菜品列表（在 allItems 中按 shopFoodId 过滤）
          const items: Array<CategoryItemModel> = allItems.filter((it) =>
            itemList.some((origin) => origin.shopFoodId === it.id),
          );

          categories.value.push({
            id: ctId,
            name: ctName,
            categoryType: ctType,
            items: items,
          });
        });

        console.log(categories.value);
        selectedCategory.value = shouldFilterByMenuTag
          ? menuTag.value
          : categories.value[0]?.name || '';
      } else {
        showDialog({
          message: categoryTagResp.msg || foodResp.msg || '加载菜品分类失败，请稍后重试',
        });
      }
    } catch (error) {
      console.error('加载菜品分类失败：', error);
      showDialog({ message: '加载菜品分类失败，请稍后重试' });
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/tableManage",
            class: "text-white mr-3"
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
            ])),
            _: 1,
            __: [12]
          }),
          _createElementVNode("h1", _hoisted_4, _toDisplayString(shopName.value || shopDetail.value?.shopName || '') + " - " + _toDisplayString(tableName.value) + " - 点餐 ", 1)
        ]),
        _createElementVNode("div", { class: "flex items-center" }, [
          _createElementVNode("button", {
            class: "mr-4",
            onClick: goToHistory
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "fas fa-history text-white" }, null, -1)
          ])),
          _createElementVNode("button", { onClick: showMenu }, _cache[14] || (_cache[14] = [
            _createElementVNode("i", { class: "fas fa-ellipsis-v text-white" }, null, -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-500 mr-2 text-xl" }, "用餐人数:", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "px-3 py-1 bg-gray-100 text-gray-700",
              disabled: hasPendingPayment.value,
              onClick: decreasePeople
            }, "-", 8, _hoisted_8),
            _createElementVNode("span", _hoisted_9, _toDisplayString(peopleCount.value), 1),
            _createElementVNode("button", {
              class: "px-3 py-1 bg-gray-100 text-gray-700",
              disabled: hasPendingPayment.value,
              onClick: increasePeople
            }, "+", 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-gray-500 mr-2" }, "就餐时间:", -1)),
          _createElementVNode("span", _hoisted_12, _toDisplayString(currentTime.value), 1)
        ]),
        (isSpecialOrder.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["flex items-center text-xl px-3 py-1.5 rounded-lg border border-gray-200 bg-gray-50", selfPickDateTime.value ? 'text-gray-800' : 'text-blue-500']),
              disabled: hasPendingPayment.value,
              onClick: showTimePicker
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-red-500 mr-1" }, "*", -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(timeLabel.value) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(selfPickDateTime.value || '请选择'), 1),
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-chevron-right ml-2 text-gray-400" }, null, -1))
            ], 10, _hoisted_13))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
                type: "text",
                placeholder: "搜索菜品",
                class: "w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              }, null, 512), [
                [_vModelText, searchKeyword.value]
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-search absolute right-3 top-3 text-gray-400" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
              return (_openBlock(), _createElementBlock("div", {
                key: cat.id,
                class: _normalizeClass(["category-item", { active: selectedCategory.value === cat.name }]),
                onClick: ($event: any) => (selectCategory(cat.name || ''))
              }, _toDisplayString(cat.name), 11, _hoisted_20))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h2", _hoisted_23, _toDisplayString(selectedCategory.value), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenuItems.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["menu-item", { 'menu-item-disabled': (item.stockQuantity ?? 0) <= 0 }]),
                "aria-disabled": (item.stockQuantity ?? 0) <= 0,
                onClick: ($event: any) => (showSpecDialog(item, $event))
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: item.image,
                    alt: item.name,
                    class: "object-cover w-full h-full"
                  }, null, 8, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h3", _hoisted_29, _toDisplayString(item.name), 1),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(item.description), 1),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, "¥" + _toDisplayString(item.price), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["menu-item-stock", { 'out-of-stock': (item.stockQuantity ?? 0) <= 0 }])
                      }, " 库存：" + _toDisplayString(item.stockQuantity ?? 0), 3)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      (getOrderItemCount(item.name || '') > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "menu-item-btn decrease",
                            onClick: _withModifiers(($event: any) => (decreaseItem(item.name || '')), ["stop"])
                          }, "-", 8, _hoisted_35))
                        : _createCommentVNode("", true),
                      (getOrderItemCount(item.name || '') > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(getOrderItemCount(item.name || '')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "menu-item-btn increase",
                        onClick: _withModifiers(($event: any) => (showSpecDialog(item, $event)), ["stop"])
                      }, "+", 8, _hoisted_37)
                    ])
                  ])
                ])
              ], 10, _hoisted_25))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          ref_key: "orderPanel",
          ref: orderPanel,
          class: "w-1/4 bg-white flex flex-col overflow-hidden min-h-0"
        }, [
          _createElementVNode("div", _hoisted_38, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "font-bold" }, "已点菜品", -1)),
            _createElementVNode("button", {
              class: _normalizeClass(["text-red-500 text-xl", { 'opacity-50': hasPendingPayment.value }]),
              disabled: hasPendingPayment.value,
              onClick: clearOrder
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("i", { class: "fas fa-trash-alt mr-1" }, null, -1),
              _createTextVNode(" 清空 ", -1)
            ]), 10, _hoisted_39)
          ]),
          _createElementVNode("div", _hoisted_40, [
            (orderItems.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "fas fa-utensils text-5xl mb-2" }, null, -1),
                  _createElementVNode("p", null, "暂无点餐，请从左侧选择菜品", -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItems.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: "order-item"
                    }, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, _toDisplayString(item.name), 1),
                        (
                    (item.specName && item.specName !== '标准') ||
                    (item.methodName && item.methodName.trim() !== '')
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (item.specName && item.specName !== '标准')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(item.specName), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (item.methodName && item.methodName.trim() !== '')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(item.specName && item.specName !== '标准' ? ' - ' : '') + _toDisplayString(item.methodName), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_46, "¥" + _toDisplayString(item.price) + " × " + _toDisplayString(item.quantity), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("button", {
                          class: "menu-item-btn decrease mr-2",
                          disabled: hasPendingPayment.value,
                          onClick: ($event: any) => (decreaseItem(item.name))
                        }, "-", 8, _hoisted_48),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(item.quantity), 1),
                        _createElementVNode("button", {
                          class: "menu-item-btn increase",
                          disabled: hasPendingPayment.value,
                          onClick: ($event: any) => (showSpecDialog(item, $event))
                        }, "+", 8, _hoisted_50)
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "order-description",
                class: "text-lg text-gray-700 shrink-0 mr-2"
              }, "订单备注", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "order-description",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderDescription).value = $event)),
                type: "text",
                maxlength: "200",
                placeholder: "选填",
                disabled: hasPendingPayment.value,
                class: "min-w-0 flex-1 px-3 py-1 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              }, null, 8, _hoisted_53), [
                [_vModelText, orderDescription.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("span", null, [
                _cache[24] || (_cache[24] = _createTextVNode("小计 ", -1)),
                _createElementVNode("span", _hoisted_55, "（共" + _toDisplayString(totalCount.value) + "份）", 1)
              ]),
              _createElementVNode("span", null, "¥" + _toDisplayString(subtotal.value.toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _cache[26] || (_cache[26] = _createElementVNode("span", null, "折扣金额", -1)),
                _createElementVNode("button", {
                  class: "ml-2 text-blue-500 hover:text-blue-700 text-sm",
                  title: "点击设置折扣",
                  disabled: hasPendingPayment.value,
                  onClick: adjustDiscount
                }, _cache[25] || (_cache[25] = [
                  _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                ]), 8, _hoisted_58)
              ]),
              _createElementVNode("span", _hoisted_59, "-¥" + _toDisplayString(discountAmount.value.toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "总计", -1)),
              _createElementVNode("span", null, "¥" + _toDisplayString(total.value.toFixed(2)), 1)
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["w-full bg-blue-500 text-white py-2 rounded-lg mt-2 font-bold", { 'opacity-50': orderItems.value.length === 0 || isSubmittingOrder.value }]),
              disabled: orderItems.value.length === 0 || isSubmittingOrder.value,
              onClick: submitOrder
            }, _toDisplayString(isSubmittingOrder.value ? '提交中...' : hasPendingPayment.value ? '继续支付' : '提交订单'), 11, _hoisted_61)
          ])
        ], 512)
      ]),
      (discountModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
                _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-xl font-bold" }, "设置折扣", -1)),
                _createElementVNode("button", { onClick: hideDiscountModal }, _cache[28] || (_cache[28] = [
                  _createElementVNode("i", { class: "fas fa-times text-gray-500" }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 rounded-lg border", 
                tempDiscountMode.value === 'amount'
                  ? 'border-blue-500 bg-blue-50 text-blue-600'
                  : 'border-gray-300 text-gray-600'
              ]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (tempDiscountMode.value = 'amount'))
                  }, " 按金额 ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 rounded-lg border", 
                tempDiscountMode.value === 'rate'
                  ? 'border-blue-500 bg-blue-50 text-blue-600'
                  : 'border-gray-300 text-gray-600'
              ]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (tempDiscountMode.value = 'rate'))
                  }, " 按比例 ", 2)
                ]),
                (tempDiscountMode.value === 'amount')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "折扣金额", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tempManualDiscountAmount).value = $event)),
                        type: "number",
                        min: "0",
                        step: "0.01",
                        class: "w-full border border-gray-300 rounded-lg px-3 py-2",
                        placeholder: "请输入折扣金额"
                      }, null, 512), [
                        [
                          _vModelText,
                          tempManualDiscountAmount.value,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "折扣比例", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tempDiscountRate).value = $event)),
                        class: "w-full border border-gray-300 rounded-lg px-3 py-2 bg-white"
                      }, _cache[31] || (_cache[31] = [
                        _createElementVNode("option", { value: 1 }, "无折扣（100%）", -1),
                        _createElementVNode("option", { value: 0.95 }, "95%", -1),
                        _createElementVNode("option", { value: 0.9 }, "90%", -1),
                        _createElementVNode("option", { value: 0.85 }, "85%", -1),
                        _createElementVNode("option", { value: 0.8 }, "80%", -1),
                        _createElementVNode("option", { value: 0.7 }, "70%", -1),
                        _createElementVNode("option", { value: 0.5 }, "50%", -1)
                      ]), 512), [
                        [
                          _vModelSelect,
                          tempDiscountRate.value,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])),
                _createElementVNode("div", _hoisted_68, "当前小计：¥" + _toDisplayString(subtotal.value.toFixed(2)), 1)
              ]),
              _createElementVNode("div", { class: "flex space-x-3" }, [
                _createElementVNode("button", {
                  class: "flex-1 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50",
                  onClick: hideDiscountModal
                }, " 取消 "),
                _createElementVNode("button", {
                  class: "flex-1 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600",
                  onClick: confirmDiscount
                }, " 确认 ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (qrModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
            _createElementVNode("div", { class: "bg-white rounded-xl p-6 w-80" }, [
              _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
                _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-xl font-bold" }, "扫码点餐", -1)),
                _createElementVNode("button", { onClick: hideQRCode }, _cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "fas fa-times text-gray-500" }, null, -1)
                ]))
              ]),
              _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"text-center\" data-v-0c2d6045><div class=\"w-48 h-48 mx-auto bg-gray-100 flex items-center justify-center mb-4\" data-v-0c2d6045><i class=\"fas fa-qrcode text-8xl text-gray-400\" data-v-0c2d6045></i></div><p class=\"text-gray-600 mb-2\" data-v-0c2d6045>请顾客扫描二维码</p><p class=\"text-gray-600\" data-v-0c2d6045>自助点餐</p></div>", 1))
            ])
          ]))
        : _createCommentVNode("", true),
      (paymentConfirmModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", { class: "payment-modal-header flex justify-between items-center" }, [
                _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择支付方式", -1)),
                _createElementVNode("button", {
                  class: "text-gray-500 hover:text-gray-700",
                  onClick: cancelPaymentConfirmation
                }, _cache[36] || (_cache[36] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-gray-600" }, "订单号:", -1)),
                    _createElementVNode("span", _hoisted_75, _toDisplayString(currentOrderNo.value || '提交后生成'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-gray-600" }, "桌号:", -1)),
                    _createElementVNode("span", _hoisted_77, _toDisplayString(tableName.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-gray-600" }, "应付金额:", -1)),
                    _createElementVNode("span", _hoisted_79, "¥" + _toDisplayString(total.value.toFixed(2)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", null, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 支付方式 ", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedPaymentMethod).value = $event)),
                      class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg",
                      onChange: handlePaymentMethodChange
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods.value, (method) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: method.value,
                          value: method.value
                        }, _toDisplayString(method.name), 9, _hoisted_81))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, selectedPaymentMethod.value]
                    ])
                  ]),
                  (selectedPaymentMethod.value === 100)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        (unsupportedFoodTicketNames.value.length > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_83, " 以下菜品不支持餐券使用，请删除后再使用餐券支付：" + _toDisplayString(unsupportedFoodTicketNames.value.join('、')), 1))
                          : _createCommentVNode("", true),
                        _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "员工工号", -1)),
                        _createElementVNode("div", _hoisted_84, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((foodTicketEmployeeNo).value = $event)),
                            type: "text",
                            inputmode: "numeric",
                            placeholder: "请输入员工工号",
                            disabled: Boolean(foodTicketCustomer.value) || hasPendingPayment.value,
                            class: "w-full min-w-0 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                            onKeyup: _withKeys(validateFoodTicketEmployee, ["enter"])
                          }, null, 40, _hoisted_85), [
                            [
                              _vModelText,
                              foodTicketEmployeeNo.value,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (!foodTicketCustomer.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "employee-validation-button px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50",
                                disabled: isValidatingEmployee.value || hasPendingPayment.value,
                                onClick: validateFoodTicketEmployee
                              }, _toDisplayString(isValidatingEmployee.value ? '查询中' : '验证'), 9, _hoisted_86))
                            : (!hasPendingPayment.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "employee-validation-button px-4 py-2 border border-blue-500 text-blue-600 rounded-lg",
                                  onClick: resetFoodTicketEmployee
                                }, " 重选 "))
                              : _createCommentVNode("", true)
                        ]),
                        (foodTicketCustomer.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                              _createElementVNode("div", null, "员工：" + _toDisplayString(foodTicketCustomer.value.customerName), 1),
                              _createElementVNode("div", null, [
                                _cache[42] || (_cache[42] = _createTextVNode(" 餐券余额： ", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["font-semibold", hasEnoughFoodTicketBalance.value ? 'text-green-600' : 'text-red-500'])
                                }, " ¥" + _toDisplayString(Number(foodTicketCustomer.value.foodTicketAccount || 0).toFixed(2)), 3)
                              ]),
                              (!hasEnoughFoodTicketBalance.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, " 餐券余额不足，请选择其他支付方式 "))
                                : _createCommentVNode("", true)
                            ]))
                          : (hasPendingPayment.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, " 该订单创建时未绑定员工，不能改用餐券支付 "))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (selectedPaymentMethod.value !== 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                        _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 备注信息 ", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((paymentRemark).value = $event)),
                          placeholder: "请输入备注信息（可选）",
                          rows: "2",
                          class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-base resize-none"
                        }, null, 512), [
                          [_vModelText, paymentRemark.value]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("button", {
                  class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
                  onClick: cancelPaymentConfirmation
                }, " 取消 "),
                _createElementVNode("button", {
                  class: _normalizeClass(["flex-1 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium", { 'opacity-50': isSubmittingOrder.value || isValidatingEmployee.value }]),
                  disabled: isSubmittingOrder.value || isValidatingEmployee.value,
                  onClick: handlePaymentConfirm
                }, _toDisplayString(isSubmittingOrder.value ? '提交中...' : '确认支付'), 11, _hoisted_92)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (scanPaymentModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
            _createElementVNode("div", { class: "bg-black bg-opacity-80 text-white px-4 py-3 flex items-center justify-between" }, [
              _createElementVNode("button", {
                class: "text-white",
                onClick: cancelScanPayment
              }, _cache[45] || (_cache[45] = [
                _createElementVNode("i", { class: "fas fa-times text-2xl" }, null, -1)
              ])),
              _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-xl font-bold" }, "B扫C收款", -1)),
              _cache[47] || (_cache[47] = _createElementVNode("div", { class: "w-8" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_94, [
              _cache[49] || (_cache[49] = _createElementVNode("div", {
                id: "qr-reader",
                class: "qr-reader-container w-full h-full"
              }, null, -1)),
              (isScanning.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_95, _cache[48] || (_cache[48] = [
                    _createElementVNode("div", { class: "scan-line" }, null, -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            (scanStatus.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-3 rounded-lg text-center", scanStatusClass.value])
                  }, [
                    _createElementVNode("p", _hoisted_97, _toDisplayString(scanStatus.value), 1)
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (scanPaymentFailModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
                _cache[51] || (_cache[51] = _createElementVNode("h3", { class: "text-xl font-bold" }, "支付确认", -1)),
                _createElementVNode("button", {
                  class: "text-gray-500 hover:text-gray-700",
                  onClick: cancelScanPaymentConfirm
                }, _cache[50] || (_cache[50] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_100, [
                _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-gray-700 text-lg" }, "支付结果未确认，请选择下一步操作。", -1)),
                (scanPaymentFailErrorMsg.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_101, " 错误信息：" + _toDisplayString(scanPaymentFailErrorMsg.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("button", {
                  disabled: isRefreshingPayment.value,
                  class: _normalizeClass([
              'w-full py-3 rounded-lg transition-colors font-medium',
              isRefreshingPayment.value
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-green-500 text-white hover:bg-green-600',
            ]),
                  onClick: confirmScanPaymentPaid
                }, [
                  (isRefreshingPayment.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_104, _cache[53] || (_cache[53] = [
                        _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                        _createTextVNode("查询支付结果中 ", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("span", _hoisted_105, "重新查询支付结果"))
                ], 10, _hoisted_103),
                _createElementVNode("button", {
                  disabled: isRefreshingPayment.value,
                  class: "w-full py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed",
                  onClick: retryScanPayment
                }, " 重新扫码支付 ", 8, _hoisted_106),
                _createElementVNode("button", {
                  disabled: isRefreshingPayment.value,
                  class: "w-full py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium disabled:text-gray-400 disabled:cursor-not-allowed",
                  onClick: cancelScanPaymentConfirm
                }, " 取消 ", 8, _hoisted_107)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showSpecModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
                _cache[55] || (_cache[55] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择规格", -1)),
                _createElementVNode("button", { onClick: hideSpecModal }, _cache[54] || (_cache[54] = [
                  _createElementVNode("i", { class: "fas fa-times text-gray-500" }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("img", {
                    src: currentFood.value.image,
                    alt: currentFood.value.name,
                    class: "w-16 h-16 rounded-lg mr-3 object-cover"
                  }, null, 8, _hoisted_112),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_113, _toDisplayString(currentFood.value.name), 1),
                    _createElementVNode("p", _hoisted_114, _toDisplayString(currentFood.value.description), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_115, [
                _cache[56] || (_cache[56] = _createElementVNode("h4", { class: "text-lg font-medium mb-3" }, "选择规格", -1)),
                _createElementVNode("div", _hoisted_116, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFood.value.specs || [], (spec) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: spec.id,
                      class: _normalizeClass(["w-full p-3 rounded-lg border flex items-center justify-between", 
                selectedSpec.value.id === spec.id ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
              ]),
                      onClick: ($event: any) => (selectedSpec.value = spec)
                    }, [
                      _createElementVNode("span", null, _toDisplayString(spec.name), 1),
                      _createElementVNode("span", _hoisted_118, "¥" + _toDisplayString(spec.price), 1),
                      (selectedSpec.value.id === spec.id)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_119))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_117))
                  }), 128))
                ])
              ]),
              (methods.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMethods.value, (attributeGroup, attributeName) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: attributeName,
                        class: "mb-4"
                      }, [
                        _createElementVNode("h4", _hoisted_121, "选择" + _toDisplayString(attributeName), 1),
                        _createElementVNode("div", _hoisted_122, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributeGroup, (method) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: method.id,
                              class: _normalizeClass(["px-3 py-1 rounded-full border text-sm", 
                  isMethodSelected(attributeName, method.id)
                    ? 'border-blue-500 bg-blue-50 text-blue-600'
                    : 'border-gray-300 text-gray-600'
                ]),
                              onClick: ($event: any) => (toggleMethodSelection(attributeName, method.id))
                            }, _toDisplayString(method.name), 11, _hoisted_123))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "flex space-x-3" }, [
                _createElementVNode("button", {
                  class: "flex-1 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50",
                  onClick: hideSpecModal
                }, " 取消 "),
                _createElementVNode("button", {
                  class: "flex-1 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600",
                  onClick: confirmAddToOrder
                }, " 确认添加 ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_van_popup, {
        show: timePickerVisible.value,
        "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((timePickerVisible).value = $event)),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_picker, {
            modelValue: timePickerValues.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((timePickerValues).value = $event)),
            columns: timePickerColumns.value,
            title: `选择${timeLabel.value}`,
            onCancel: _cache[10] || (_cache[10] = ($event: any) => (timePickerVisible.value = false)),
            onChange: handleTimePickerChange,
            onConfirm: handleTimePickerConfirm
          }, null, 8, ["modelValue", "columns", "title"])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createVNode(ConfirmDialog, {
      ref_key: "confirmDialog",
      ref: confirmDialog,
      message: confirmMessage.value,
      title: confirmTitle.value
    }, null, 8, ["message", "title"])
  ], 64))
}
}

})